import { Head } from "@inertiajs/react";
import { Layout } from "@/components/Layout";
import { CredentialsForm } from "@/components/CredentialsForm";

export default function Register({ token, label }: { token: string; label: string | null }) {
  return (
    <Layout>
      <Head title="Join" />
      <div className="mx-auto max-w-sm rounded-xl border border-neutral-200 bg-white p-6 dark:border-neutral-800 dark:bg-neutral-900">
        <h1 className="text-xl font-semibold tracking-tight">
          {label ? `Welcome, ${label}` : "Join Court Pilot"}
        </h1>
        <p className="mt-1 mb-6 text-sm text-neutral-500 dark:text-neutral-400">
          Connect your club account and Court Pilot will book courts for you
          the moment they are released.
        </p>
        <CredentialsForm action={`/join/${token}`} submitLabel="Connect my account" />

        {/* Kept short and reassuring on the join page; the full guide lives
            behind sign-in now, so a public visitor cannot read what the
            service does. */}
        <p className="mt-6 border-t border-neutral-200 pt-4 text-sm text-neutral-500 dark:border-neutral-800 dark:text-neutral-400">
          Your password is used once to connect your account and is never stored.
          You can disconnect at any time.
        </p>
      </div>
    </Layout>
  );
}
